let _sessionToken = undefined

export const SessionTokenManager = {
  get: () => _sessionToken,
  set: token => {
    _sessionToken = token
  },
}
